mutation CloseThread($input: ThreadCloseInput!) {
    threadClose(input: $input) {
        thread {
            id
        }
    }
}
